import React from 'react';
import { FiCheckCircle } from "react-icons/fi";

const AccountView = ({ data }) => {
    const accountInfo = [
        { label: "Email", value: data.email || "juned.globallywebsolutions@gmail.com" },
        { label: "Mobile number", value: data.mobile || "9571117702" },
        { label: "Username", value: "ddvhlKEFSo", isVerified: true },
        { label: "Subscription Plan", value: "Prime Subscription" },
    ];

    return (
        <div className="bg-white rounded-[10px] border border-[#E0E0E0] p-6 md:p-12 min-h-auto md:min-h-[500px] shadow-sm animate-in fade-in duration-500">
            <div className="max-w-[750px] mx-auto text-left pt-2 md:pt-6">

                <div className="flex flex-col gap-6 md:gap-8">
                    {accountInfo.map((item, idx) => (
                        <div key={idx} className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-10 sm:ml-14">
                            <div className="flex items-center gap-2 shrink-0">
                                <span className="w-full sm:w-[180px] sm:text-right text-[15px] md:text-[18px] font-[500] text-[#000000] tracking-tight">
                                    {item.label} 
                                </span>
                                <span className="hidden sm:inline font-bold text-[#333]">:</span>
                            </div>

                            <div className="flex flex-wrap items-center gap-3">
                                <span className="text-[14px] md:text-[16px] font-medium text-[#333] break-all">
                                    {item.value}
                                </span>
                                {item.isVerified && (
                                    <div className="flex items-center gap-1.5 bg-white border border-gray-100 px-2 py-0.5 rounded-full shadow-sm">
                                        <FiCheckCircle className="text-[#21C11E] text-[16px] md:text-[18px]" />
                                        <span className="text-[12px] md:text-[14px] font-bold text-[#333]">Verified</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default AccountView;